<template>
  <div class="notfound">
    <div>
      <h1>You're missing something!.</h1>
      <h2>What you're looking for, is not here.</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "notFound",
  title: "404 - Nethanzêl"
};
</script>

<style scoped lang="scss">
.notfound {
  will-change: opacity;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
}

h1 {
  font-size: 75px;
  letter-spacing: 3px;
  pointer-events: none;
  user-select: none;
}

h2 {
  font-size: 35px;
  letter-spacing: 2px;
  pointer-events: none;
  user-select: none;
}
</style>
